module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/octopus-english.b555d559.jpg";